import index from './translations/index.json';

export default {
  translation: {
    index,
  },
};
